export type MoneyManagement = number;

export function getMoneyManagementLabel(
    value: number | string | null | undefined,
    challengeMoneyManagement: number
): string {
    if (value == null || value === "") return "";
    const n = typeof value === "number" ? value : Number(value);
    if (!Number.isFinite(n)) return String(value);
    if (n === challengeMoneyManagement) return "Challenge";
    return `${n}€`;
}
